import * as types from './fareActionType'
const initialState = {
    listCommissionGroup: [],
    userList: [],
    fareList: [],
    roundOffList: [],
}
const FareReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.ROUND_OFF_LIST:
            return {
                ...state,
                roundOffList: action.payload
            }
        case types.LIST_COMMISSION_GROUP:
            return {
                ...state,
                listCommissionGroup: action.payload
            }
        case types.LIST_USER:
            return {
                ...state,
                userList: action.payload
            }
        case types.UPDATE_FARE_TYPE:
            return {
                ...state,
                fareList: action.payload
            }
        default:
            return state;
    }
}
export default FareReducer;
